const dateFormatter = new Intl.DateTimeFormat('es-CO', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
});

const dateTimeFormatter = new Intl.DateTimeFormat('es-CO', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export function formatDate(date: string | Date | null | undefined): string {
  if (!date) return '—';
  try {
    return dateFormatter.format(new Date(date));
  } catch {
    return '—';
  }
}

export function formatDateTime(date: string | Date | null | undefined): string {
  if (!date) return '—';
  try {
    return dateTimeFormatter.format(new Date(date));
  } catch {
    return '—';
  }
}

export function formatRelative(date: string | Date | null | undefined): string {
  if (!date) return '—';
  try {
    const d = new Date(date);
    const diffMs = Date.now() - d.getTime();
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHour = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHour / 24);

    if (diffSec < 60) return 'hace un momento';
    if (diffMin < 60) return `hace ${diffMin} min`;
    if (diffHour < 24) return `hace ${diffHour} h`;
    if (diffDay < 30) return `hace ${diffDay} días`;
    return formatDate(d);
  } catch {
    return '—';
  }
}
